"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.DatagridFiltersSlot = (_a) => {
    var { children } = _a, otherProps = __rest(_a, ["children"]);
    return (React.createElement("div", Object.assign({ className: "filter-fields" }, otherProps), children));
};
exports.DatagridFiltersSlot.displayName = 'DatagridFiltersSlot';



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/DatagridFiltersSlot.tsx
// module id = 254
// module chunks = 0